__turbopack_context__.v({
  "mobileNoAccess": "pageHeaderWrapper-module-scss-module__o18qua__mobileNoAccess",
  "pageHeader": "pageHeaderWrapper-module-scss-module__o18qua__pageHeader",
  "pageHeaderButtons": "pageHeaderWrapper-module-scss-module__o18qua__pageHeaderButtons",
  "pageHeaderNoWrap": "pageHeaderWrapper-module-scss-module__o18qua__pageHeaderNoWrap",
  "pageHeaderTitle": "pageHeaderWrapper-module-scss-module__o18qua__pageHeaderTitle",
});
